/**
 * Step 13 (was step 17) — Paywall: 7-day Premium trial card
 *
 * Spec: specs/onboarding-rebuild.md → Act 3 step 13
 *
 * Variant scaffolding retired 2026-05-14 — synthesis is production.
 *
 * 2026-05-16 changes:
 *   - Layout B (annual-pushed 3-tier comparison) retired. Trial scoping
 *     locked to monthly-only; annual + founding live as a slim CommitRow
 *     beneath the trial hero with cross-out / discount % pricing.
 *   - Tower chart + premiumPriceLine retired. The chart's anchors
 *     (YouVersion Premium, BibleProject+, Logos $279) were wrong/stale and
 *     credibility-damaging. Replacement: no chart. Personalized checklist
 *     does the persuasion; TrustSignals carry the $12.49/mo disclosure.
 *   - Headline + sub copy rewritten to "Free for 7 days. No catch." /
 *     "Cancel in 2 taps. $12.49/mo after." (Option C, founder voice).
 *   - Trial checklist scrubbed of free-tier and unbuilt features; now
 *     lists only PRODUCTS.md `Premium` capabilities.
 */

import PaywallTrialSynthesis from './PaywallTrial.synthesis'

// Only `freeLink` is consumed by the synthesis component now. Everything
// else (trialHeadline, trialBody, anchorStack, premiumPriceLine, foundingLabel)
// was retired in the 2026-05-16 paywall rewrite. The constant is preserved
// as a single object for future flexibility — adding `freeLink` variations
// per persona or A/B test stays a one-line change here.
export const PAYWALL_COPY = {
  freeLink: 'Continue with Free →',
}

export default function PaywallTrialStep({
  onStartTrial,
  onChooseAnnual,
  onChooseFounding,
  onContinueFree,
  hasUsedTrial = false,
  profile,
  foundingSpotsLeft,
}) {
  return (
    <PaywallTrialSynthesis
      onStartTrial={onStartTrial}
      onChooseAnnual={onChooseAnnual}
      onChooseFounding={onChooseFounding}
      onContinueFree={onContinueFree}
      hasUsedTrial={hasUsedTrial}
      copy={PAYWALL_COPY}
      profile={profile}
      foundingSpotsLeft={foundingSpotsLeft}
    />
  )
}
